import * as types from "./types";

export const fetchingUser = user_guid => ({
  type: types.FETCHING_USER,
  user_guid: user_guid,
  loading: true
});

export const resendingActivationEmail = () => ({
  type: types.RESENDING_ACTIVATION_EMAIL,
  loading: true
});

export const updatingUser = () => ({
  type: types.UPDATING_USER,
  loading: true
});

export const stopLoader = () => ({
  type: types.UPDATING_USER_COMPLETE,
  loading: false
});

export const updatedUser = user => ({
  type: types.UPDATED_USER,
  user: user,
  loading: false
});

export const fetchedUser = user => ({
  type: types.FETCHED_USER,
  user: user,
  loading: false
});

export const errorFetchingUser = error => ({
  type: types.ERROR_FETCHING_USER,
  error: error,
  loading: false
});

export const errorResendingActivationEmail = error => ({
  type: types.ERROR_RESENDING_ACTIVATION_EMAIL,
  error: error,
  loading: false
});

export const errorUpdatingUser = error => ({
  type: types.ERROR_UPDATING_USER,
  error: error,
  loading: false
});

export const errorResetUserPassword = error => ({
  type: types.ERROR_RESET_USER_PASSWORD,
  error: error,
  loading: false
});

export const errorOnActivateAccount = error => ({
  type: types.ERROR_ACTIVATE_ACCOUNT,
  error: error,
  loading: false
});
